import { PureComponent } from "react";
import { connect } from "react-redux";

import { ModalContainer } from "./privacy-settings-modal-style";
import ToggleSwitch from "designer/builder/ui/views/toggle-switch/toggle-switch";
import { RootState } from "store/types";
import { getUserFlags, isUserData, UserDataAndState } from "common/Database";
import * as actions from "actions/actions";
import { X } from "common/react-plucked";
import { CloseButton } from "../modal/modal-style";
import { MappedThunk } from "actions/action-thunk";
import { setTrackingConsent } from "common/tracking-consent";
import { dontAwait } from "common/Support";
import { setAuthPersistence } from "lib/firebase-auth";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";
import { ButtonVNext } from "designer/ui/smart/button-vnext/button-vnext";

interface Props {
    readonly userData: UserDataAndState;
    readonly setUserFlags: MappedThunk<typeof actions.setUserFlags>;
    readonly modals: SimpleModalContextProps;
}

interface State {
    value: boolean;
}

class PrivacySettingsModalImpl extends PureComponent<Props, State> {
    public state: State = {
        value: false,
    };

    componentDidMount() {
        const { userData } = this.props;

        if (!isUserData(userData)) return;
        const flags = getUserFlags(userData);

        this.setState({ value: flags.builderTrackingOptOut });
    }

    private onCheckboxChange = (value: boolean) => {
        this.setState({ value });
    };

    private onSave = () => {
        const { userData, setUserFlags } = this.props;
        const { value } = this.state;

        if (!isUserData(userData)) return;

        setUserFlags(userData, { builderTrackingOptOut: value });
        setTrackingConsent(!value);
        dontAwait(setAuthPersistence(!value));

        this.props.modals.DEPRECATED_removeAllModals();
    };

    public render() {
        const { userData } = this.props;
        const { value } = this.state;

        if (!isUserData(userData)) return null;
        const flags = getUserFlags(userData);

        return (
            <ModalContainer>
                <div className="header">
                    <span>
                        <em>Privacy Settings</em>
                    </span>
                    <CloseButton onClick={this.props.modals.DEPRECATED_removeAllModals}>
                        <X size={14} />
                    </CloseButton>
                </div>
                <div className="content">
                    <ToggleSwitch
                        label="Opt out of cookies and tracking"
                        checked={value}
                        onChange={this.onCheckboxChange}
                        isEnabled={true}
                    />
                    <div className="info">
                        When checked, Glide will not use cookies to track your account. You will have to sign into Glide
                        every time you open it.
                    </div>
                    <div className="info">We recommend leaving this setting off.</div>
                </div>
                <div className="privacy-settings-footer">
                    <ButtonVNext
                        onClick={this.props.modals.DEPRECATED_removeAllModals}
                        buttonType={"secondary"}
                        variant={"default"}
                        size={"md"}
                        label={"Cancel"}
                    />
                    <ButtonVNext
                        disabled={flags.builderTrackingOptOut === value}
                        onClick={this.onSave}
                        buttonType={"primary"}
                        variant={"default"}
                        size={"md"}
                        label={"Save"}
                    />
                </div>
            </ModalContainer>
        );
    }
}

const mapState = (state: RootState) => ({
    userData: state.userData,
});

const mapDispatch = {
    setUserFlags: actions.setUserFlags,
};

export const PrivacySettingsModal = withModalProvider(connect(mapState, mapDispatch)(PrivacySettingsModalImpl));
